// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"25318a13","977":"d5c77ab0"}[chunkId] + ".chunk.js";
};